import { useEffect } from "react";
import { useLocation } from "react-router";

export default function ScrollToTop(){
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0); // Scrolls to the top-left corner of the window
    }, [pathname]); // Re-run effect whenever the pathname changes

    return null;   
}